import { render, staticRenderFns } from "./alert_modal.vue?vue&type=template&id=297aedce&scoped=true&"
import script from "./alert_modal.vue?vue&type=script&lang=js&"
export * from "./alert_modal.vue?vue&type=script&lang=js&"
import style0 from "./alert_modal.vue?vue&type=style&index=0&id=297aedce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297aedce",
  null
  
)

export default component.exports